import React, { useState } from 'react';
import { Chip } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import ContractAppService from '../../../../application/platform/scp/contract/contract-app-service';
import { usePagedList } from '../../../../hooks/use-paged-list';
import { dataGridDefaults } from '../../../../components/list-grid-panel';
import { EditAction } from '../../../../components/row-actions';
import { formatCurrency } from '../../../../utils/format';
import { formatDate } from '../../../../utils/date';
import { IAmendmentPageRequest } from '../../../../model/scp/contract/amendment/request/amendment-paged-request';
import { IAmendmentPagedResponse } from '../../../../model/scp/contract/amendment/response/amendment-paged-response';

export interface AmendmentDataTableProps {
    parameters: IAmendmentPageRequest;
    onEdit: (row: IAmendmentPagedResponse) => void;
}

// A API de aditivos pagina a partir de 1; a grade trabalha com página 0
export default function AmendmentDataTable({ parameters, onEdit }: AmendmentDataTableProps) {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: parameters.pageSize ?? 100 });
    const [searchTrigger, setSearchTrigger] = useState(0);
    const { rows, rowCount, loading } = usePagedList(
        ContractAppService.listContractAmendments,
        { ...parameters, page: paginationModel.page + 1, pageSize: paginationModel.pageSize },
        searchTrigger,
        'Não foi possível carregar os aditivos'
    );

    const columns: GridColDef<IAmendmentPagedResponse>[] = [
        { field: 'contractTermNumber', headerName: 'Nº Termo', flex: 1, minWidth: 120, sortable: false },
        {
            field: 'contractTermType', headerName: 'Tipo', flex: 1, minWidth: 150, sortable: false,
            renderCell: (params) => <Chip size="small" label={params.value || '-'} color="primary" />
        },
        { field: 'supplierCompanyName', headerName: 'Fornecedor', flex: 1.5, minWidth: 180, sortable: false },
        {
            field: 'signDate', headerName: 'Data de assinatura', flex: 1, minWidth: 150, sortable: false,
            valueFormatter: ({ value }) => formatDate(value ? String(value) : undefined) || '-',
        },
        {
            field: 'increaseValue', headerName: 'Valor acrescido', flex: 1, minWidth: 150, sortable: false, align: 'right', headerAlign: 'right',
            valueFormatter: ({ value }) => (value ? formatCurrency(Number(value)) : '-'),
        },
        {
            field: 'actions', headerName: 'Ações', width: 90, sortable: false, filterable: false,
            renderCell: (params) => <EditAction onClick={() => onEdit(params.row)} />
        }
    ];

    return (
        <DataGrid
            {...dataGridDefaults}
            rows={rows}
            columns={columns}
            loading={loading}
            rowCount={rowCount}
            getRowId={(row: IAmendmentPagedResponse) => row.sequentialContractTerm}
            paginationMode="server"
            paginationModel={paginationModel}
            onPaginationModelChange={(model) => {
                setPaginationModel(model);
                setSearchTrigger((current) => current + 1);
            }}
        />
    );
}
